import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import { Breadcrumb, Title } from "../../Components/Atoms";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@chakra-ui/react";
import { EditModelIcon, CallIcon, MailIcon } from "../../Assets/images/svgs";
import ROUTES from "../../Routes/paths";
import { getDealerDetails } from "../../APIs";
import { DevicesOverview } from "../../Widgets"
import { OrdersTable } from "../../Components/Organisms";

const DealershipProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [ dealerDetails, setDealerDetails ] = useState({});
  const [searchParams] = useSearchParams();
  const dealerId = useRef(searchParams.get("idx"));

  useEffect(() => {
    getDealerDetails(dealerId.current, (err, data) => {
      if (err) console.error(err);
      else setDealerDetails(data[0]);
    })
  }, [ dealerId ]);


  const paths = [
    { idx: 0, name: `${location.state && location.state.from ? "OEM Dealers" : "Dealerships"}`, link: `${location.state && location.state.from ? location.state.from : ROUTES.SHOW_DEALERS}` },
    { idx: 1, name: `${(dealerDetails && dealerDetails.nm ) ? dealerDetails.nm : ""}` },
  ];

  return (
    <div className="dealership-info-container">
      <div className="bread-crumb-container">
        <Breadcrumb paths={paths} />
      </div>

      <div className="dealership-info">
        <div className="dealership-info-header">
          <Title>{(dealerDetails && dealerDetails.nm ) ? dealerDetails.nm : "--"}</Title>
          <div className="btn-container">
            <Button
              className="edit-btn"
              onClick={() => {
                navigate(
                  `${ROUTES.SHOW_DEALERS}/${ROUTES.EDIT_DEALER}?idx=${dealerId.current}`,
                  {
                    state: {
                      dealerDetails: dealerDetails ||  {},
                    },
                  }
                );
              }}
            >
              <EditModelIcon />
              Edit
            </Button>
          </div>
        </div>

        <div className="deatil-container">
          <div className="detail-box">
            <h3>Dealership Details</h3>
            <div className="detail1">
               <p className="phone-no-container">
                <CallIcon />
                <span className="phone-no">
                  {dealerDetails && <dealerDetails className="mob"></dealerDetails> ? dealerDetails.mob : "--"},
                </span>{" "}
                <span className="phone-no">
                  {dealerDetails && dealerDetails.amob ? dealerDetails.amob : "--"}
                </span>
               </p>
              <p className="mail-container">
                <MailIcon />
                <span className="mail">
                  {dealerDetails && dealerDetails.eml ? dealerDetails.eml : "--"}
                </span>
              </p>
            </div>
            <div className="detail2">
            <p className="oem-container">
                <span className="key">OEM:</span>
                <span className="oem">{dealerDetails && dealerDetails.vmk ? dealerDetails.vmk : "--"}</span>
               </p>
              <p className="gst-container detail-row">
                <span className="key">GST Number :</span>
                <span className="gst">{dealerDetails && dealerDetails.gstno ? dealerDetails.gstno : "--"}</span>
              </p>
              <p className="detail-row">
                <span className="key">Address :</span>
                <span className="address">
                  {dealerDetails && dealerDetails.add ? dealerDetails.add : "--"}
                </span>
              </p>
            </div>
          </div>

          <div className="detail-box">
            <h3>Contact Person Details</h3>
            <div className="detail3">
              <span className="dm-name">
                {dealerDetails && dealerDetails.dnm ? dealerDetails.dnm :"--"}
              </span>
              <span className="dm-position">
                {dealerDetails && dealerDetails.ddes ? dealerDetails.ddes: "--"}
              </span>
            </div>
            <div className="detail1">
              <p className="phone-no-container">
                <CallIcon />
                <span className="phone-no">
                  {dealerDetails && dealerDetails.dmob ? dealerDetails.dmob: "--"}
                </span>
              </p>
              <p className="mail-container">
                <MailIcon />
                <span className="mail">
                  {dealerDetails && dealerDetails.deml ? dealerDetails.deml: "--"}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="devices-overview-count">
        <DevicesOverview />
      </div>

      <div className="filtered-orders-table">
        <OrdersTable title={"Shipment Details"} filterHeaders={true} dealerId={dealerId.current} shipment={true} />
      </div>
    </div>
  );
};

export default DealershipProfile;
